import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/shared/constants';
import type { Features } from '@/shared/ui';
import { useFeatureFlags } from '@/shared/ui';

interface Props {
  feature: Features;
}

export function FeatureGuard({ feature }: Props) {
  const { isFeatureAvailable } = useFeatureFlags();

  if (!isFeatureAvailable(feature)) {
    return <Navigate to={ROUTES.home} />;
  }

  return <Outlet />;
}
